import { TRANSCRIBER_DASHBOARD } from "../settings";

export function redirectToTranscriberPlatform() {
  window.location.replace(TRANSCRIBER_DASHBOARD);
}